import {
  getFromLocalStorage,
  setToLocalStorage,
} from '@components/userDocuments/editDocument/shared/symbols/functionForLocalStorage';
import { socketReadyStates } from '@constants/webSocketActionsAndScreens';
import Logger from '@utility/services/Logger';
import { Auth } from 'aws-amplify';

export const handleSignOut = (params) => {
  const { signOut, clearUserInfo, webSocket } = params;
  if (webSocket.readyState === socketReadyStates.OPEN) webSocket.close();

  // TODO: remove recentlyUsedSymbols logic once we implemented this in DB
  const { inviteId: userName } = params;
  const recentlyUsedSymbols = getFromLocalStorage(
    `${userName}recentlyUsedSymbols`,
  );
  const cookie = getFromLocalStorage(`acceptCookie`);
  const sp = localStorage.getItem('sp');
  localStorage.clear();
  setToLocalStorage(`${userName}recentlyUsedSymbols`, recentlyUsedSymbols);
  if (cookie) {
    setToLocalStorage(`acceptCookie`, true);
  }
  Logger.ClearUserLogScope();
  // history.push('/');
  signOut();
  clearUserInfo();
  Auth.signOut();
  if (
    process.env.REACT_APP_ENVIRONMENT !== 'production' &&
    sp === 'oregonstate.edu'
  ) {
    window.location.href = `https://${process.env.REACT_APP_CUSTOM_DOMAIN}/logout?client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}&logout_uri=${process.env.REACT_APP_REDIRECT_SIGNOUT}`;
  } else {
    window.location.href = `https://${sp === 'Google' ? process.env.REACT_APP_CUSTOM_DOMAIN : process.env.REACT_APP_DOMAIN}/logout?client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}&logout_uri=${process.env.REACT_APP_REDIRECT_SIGNOUT}`;
  }
};
